import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./useAuth";

/** Routen, die Personalwesen (nicht nur Dienstplanung) brauchen. */
export function RequireStaffHr(props: { children: React.ReactNode }) {
  const auth = useAuth();
  if (auth.info?.staffHrEnabled === false) return <Navigate to="/forbidden" replace />;
  return <>{props.children}</>;
}

export function RequireStaffTimeTracking(props: { children: React.ReactNode }) {
  const auth = useAuth();
  if (!auth.info?.staffTimeTrackingEnabled) return <Navigate to="/forbidden" replace />;
  return <>{props.children}</>;
}
